import BlobFilePreview from "@/components/BlobPreview";
import { legalMailAttachmentBlob } from "@/lib/api";

/**
 * The preview of a legal mail-inbox attachment, shown by what the file is rather than what the sender
 * called it. The sender chooses both the name and the declared content type, so a `statement.pdf`
 * declared as `text/html` must never reach a frame; `BlobPreview` decides from the blob's own type.
 * Kept apart from the dialog so it carries no Radix component, which the pinned Jest resolver cannot
 * mount.
 *
 * @param {{messageId: string, att: {id: string, name?: string}}} props
 */
export default function MailAttachmentPreview({ messageId, att }) {
  return (
    <BlobFilePreview
      loadKey={`${messageId}:${att.id}`}
      load={(signal) => legalMailAttachmentBlob(messageId, att.id, signal)}
      name={att.name || "file"}
      frameClassName="w-full h-[72vh] border rounded bg-white"
      imageClassName="max-w-full max-h-[72vh] mx-auto object-contain"
      testIdPrefix="mail-attachment-preview"
    />
  );
}
